import React from 'react';
import { connect } from 'react-redux';
import { uploadAttachment } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import { mdiUpload } from '@mdi/js';
import Icon from '@mdi/react';
import { nanoid } from 'nanoid';
import { Field, reduxForm } from 'redux-form';

const actions = {
  closeModal,
  uploadAttachment,
};

function ModalFileEdit({ data, uploadAttachment, closeModal }) {
  const { id, auth, history, page, item, title, description, category, url } =
    data;

  const handleSendFile = (fileItem) => {
    let data = {
      id,
      title,
      description,
      url,
      category,
      attachments: fileItem.attachments,
      file: fileItem.file,
      key: fileItem.key,
    };
    uploadAttachment(auth, history, data);
  };

  const handleUploadAttachment = (e, input) => {
    e.preventDefault();

    let file = e.target.files?.[0];
    if (!file) return;

    let key = nanoid();
    let attachment = {
      key: key,
      filename: file.name,
      filesize: file.size,
      filetype: file.type,
      filelink:
        `files/page/${auth.userId}/${id}/${Date.now()}_` +
        file.name.split(',').join('').split(' ').join('-'),
    };
    let attachments = page?.attachments ? JSON.parse(page.attachments) : [];
    let updateAttachments = attachments.map((att) => {
      if (att?.key === item?.key) return { ...attachment };
      return att;
    });

    let fileItem = {
      file: file,
      key: key,
      attachments: updateAttachments,
    };
    handleSendFile(fileItem);
    closeModal();
  };

  const renderFileInput = ({
    input,
    type,
    meta,
    label,
    placeholder,
    fileNames,
  }) => {
    return (
      <div className='field'>
        <div className='label'>{label}</div>
        <div className='control'>
          <div className='file has-name is-fullwidth'>
            <label className='file-label'>
              <input
                name={input.name}
                accept='image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.ppt,.pptx,.xls,.xlsx,.zip'
                className='file-input'
                type={type}
                onChange={(event) => handleUploadAttachment(event, input)}
              />
              <span className='file-cta'>
                <span className='file-icon'>
                  <span className='icon is-small'>
                    <Icon path={mdiUpload} size={1} />
                  </span>
                </span>
                <span className='file-label'>{placeholder}</span>
              </span>
              <span className='file-name'>{fileNames}</span>
            </label>
          </div>
        </div>
        {meta && meta.invalid && meta.error && <div>{meta.error}</div>}
      </div>
    );
  };

  return (
    <Modal variant='info' closeModal={closeModal} width={500}>
      <div className='mx-2 mt-3'>
        <p className='my-3'>
          Existing File: <br />
          <span className='has-text-info has-text-weight-semibold'>
            {item?.filename}
          </span>
        </p>
        <Field
          name='attachment'
          type='file'
          component={renderFileInput}
          placeholder='File'
          label='File Attachement'
        />
        <div className='flex justify-end align-center pt-2'>
          <div className='buttons'>
            <Button cvariant='cback' onClick={closeModal} />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default connect(
  null,
  actions
)(
  reduxForm({
    form: 'pageEdit',
  })(ModalFileEdit)
);
